import { render, staticRenderFns } from "./PeraltaClientNav.vue?vue&type=template&id=d08ac9ce&"
import script from "./PeraltaClientNav.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PeraltaClientNav.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports